import Vue from 'vue'
import Vuex from 'vuex'
import home from './module/home'
import tagsView from './module/tagsView'
import tag from './module/tag'
// import permission from './module/permission'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    name: '2222',
  },
  mutations: {},
  modules: {
    home,
    tagsView,
    tag,
    // permission
  }
})
export default store